import $ from 'jquery';
import datepicker from 'js-datepicker'
import selectize from 'selectize';

import Modal from '../../components/Modal';
import Request from '../../components/request';
import Utils from '../../components/utils';
import Validation from '../classes/Validation';
import Vars from "../../vars";

class Partner {
    constructor (args) {
        let self = this;

        self._setArgs(args);
        self._init();
    };

    _elems = {
        $content : $(),
        promocode : {
            $attach : $(),
            $modal  : $(),
            $form   : $()
        }
    };

    _const = {
        entities : 'partners',
        entity   : 'partner',
        id       : 'id'
    };

    _args = {
        page : ''
    };

    _state = {
        item       : {},
        items      : {},
        promocode  : {
            entity    : 'promocode',
            item      : {},
            fields    : {},
            partnerId : null
        },
        tariffs    : []
    };

    _utils = {
        promocode : {
            validation : {}
        }
    };

    _setArgs = (args) => {
        let self = this;

        self._args.page  = args.page;
        self._args.title = args.title;
    };

    _setFields = () => {
        let self = this;

        self._state.fields = {};
    };

    _setPromocodeValidation = () => {
        let self = this;

        if (!self._elems.promocode.$form.length) return;

        self._utils.promocode.validation = new Validation({
            form : self._elems.promocode.$form
        });
    };

    _bindElements = () => {
        let self = this;

        self._elems.$content = !self._elems.$content.length ? $('.content') : self._elems.$content;
        if(!self._elems.$content.length) return;

        self._elems.promocode.$attach = self._elems.$content.find('.js-partner-attach-promocode')
    };

    _bindUI = () => {
        let self = this;

        self._elems.promocode.$attach.length && self._elems.promocode.$attach.unbind('click').on('click', function(e){
            e.preventDefault();
            self._state.promocode.partnerId = $(this).data('id');
            self._bindPromocodeAttach();
        })
    };

    _bindPromocodeAttach = () => {
        let self = this;

        loader.increase();
        Request.send({
            path: '/api/options?only=tariffs',
            done: function(response) {
                loader.decrease();
                Utils.scrollToTop();

                self._state.tariffs = response.options.tariffs
                self._initPromocodeModal()
            }
        });
    };

    _setPromocodeFields = () => {
        let self = this;

        self._state.promocode.fields = {
            discount_type : {
                title     : 'Тип скидки',
                type      : 'select',
                required  : true,
                value     : null,
                options   : ifacade.constants.promocodes.types
            },
            discount : {
                title     : 'Размер скидки',
                type      : 'number',
                required  : true
            },
            is_reusable : {
                title    : 'Многоразовый',
                type     : 'checkbox',
                required : true,
                value    : true
            },
            count_uses : {
                title    : 'Сколько раз можно использовать',
                type     : 'number',
                required : true
            },
            until_at : {
                title    : 'Дата окончания действия',
                type     : 'date',
                required : true
            },
            to_tariffs    : {
                title    : 'Прикрепить к тарифному плану',
                type     : 'checkbox'
            },
            tariff_packages :    {
                title    : '',
                type     : 'select',
                name     : 'display_name',
                multiple : true,
                id       : 'id',
                group    : 'packages',
                options  : self._state.tariffs,
                hidden   : true
            },
            count : {
                type  : 'hidden',
                value : 1
            },
            partnerId : {
                type  : 'hidden',
                value : self._state.promocode.partnerId
            }
        }
    };

    _initPromocodeModal = () => {
        let self = this;

        self._setPromocodeFields();

        self._elems.promocode.$modal = new Modal({
            title : 'Добавление нового промокода',
            closingConfirmation : true,
            confirm : function(args){
                self._bindPromocodeSubmit(args);
            },
            content: Utils.renderProfileTemplate('form', {
                item     : self._state.promocode.item,
                entity   : self._state.promocode.entity,
                fields   : self._state.promocode.fields,
                buttons  : {
                    one : {
                        class : 'confirm button--edit',
                        title : 'Добавить',
                        type  : 'submit'
                    },
                    two : {
                        class : 'button--cancel',
                        title : 'Отмена'
                    }
                }
            })
        });

        self._elems.promocode.$form = self._elems.promocode.$modal.find('form');

        self._setPromocodeValidation();
        self._bindPromocodeForm();
    };

    _bindPromocodeForm () {
        let self = this;

        let $form = self._elems.promocode.$form;
        datepicker('input[data-type="date"]', {
            customDays : ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'],
            customMonths : ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
            formatter: (input, date, instance) => {
                const value = date.toLocaleDateString()
                input.value = value
            }
        });
        $form.find('select[multiple=multiple]').selectize();

        $form.find('.form-field[data-name="is_reusable"] .checkbox').on('change', function(){
            if($(this).hasClass('checked')){
                let $field = $form.find('.form-field[data-name="count_uses"]');
                $field.find('input').removeAttr('required');
                $field.slideDown();
            }
            else {
                let $field = $form.find('.form-field[data-name="count_uses"]');
                $field.find('input').removeAttr('required');
                $field.slideUp();
            }
        });

        $form.find('.form-field[data-name="to_tariffs"] .checkbox').on('change', function(){
            let $field = $form.find('.form-field[data-name="tariff_packages"]');
            if($(this).hasClass('checked')) {
                $field.hide().removeClass('hidden').slideDown();
            }
            else {
                $field.slideUp();
            }
        });

        $form.find('.form-field[data-name="to_users"] .checkbox').on('change', function(){
            let $field = $form.find('.form-field[data-name="users"]');
            if($(this).hasClass('checked')) {
                $field.hide().removeClass('hidden').slideDown();
            }
            else {
                $field.slideUp();
            }
        });
    };

    _bindPromocodeSubmit = () => {
        let self = this;

        loader.increase();
        Request.send({
            path : '/api/promocodes/create',
            method : 'POST',
            data   : self._elems.promocode.$form.serialize(),
            done   : function (response) {
                loader.decrease();

                if (response.error) {
                    self._utils.validation.showErrors(response.error);
                    return;
                }

                self._elems.promocode.$modal.trigger('close');
                self._list();
            }
        })
    };

    _list = () => {
        let self = this;

        self._bindElements();

        Request.send({
            path: '/api/' + self._const.entities,
            done: function(response) {
                loader.decrease();
                Utils.scrollToTop();

                const { data } = response
                self._state.items = data;

                self._state.breadcrumbs = Utils.renderProfileTemplate('breadcrumbs', {
                    crumbs : [
                        {
                            title : 'Главная',
                            href  : '#'
                        },
                        {
                            title : self._args.title
                        }
                    ],
                    dropdown : null,
                    activate : null
                });

                self._elems.$content.html(Utils.renderProfileTemplate(self._const.entities, {
                    breadcrumbs            : self._state.breadcrumbs,
                    [self._const.entities] : self._state.items
                }));

                self._bindElements();
                self._bindUI();
            }
        });
    };

    _init = () => {
        let self = this
        if (self._args.page === Vars.page.list) {
            self._list();
        }
    };
}

export default Partner;